import React, { useEffect, useRef, useState } from "react"
import { Controller, useFormContext } from "react-hook-form"
import { InputText } from "src/shared/components/forms"
import Icon from "src/shared/icons"
import { validateOnlyNumbers } from "src/shared/sections/payment/Payment.helpers"
import { useGetEasyrewardsLazyQuery } from "src/gql/schema"
import "./LovePointsInput.css"

interface LovePointsInputProps {
    setLovePointsAmount: (amount: { id: string; saldo: number }) => void
    className?: string
    index?: number
    controlParams?: any
    width?: string
    triggerSearch?: number
    onNotFound?: () => void
}

const LovePointsInput: React.FC<LovePointsInputProps> = ({
    setLovePointsAmount,
    className,
    index = 0,
    controlParams,
    width,
    triggerSearch,
    onNotFound,
}) => {
    const { control } = useFormContext()
    const [search, setSearch] = useState<string>("")
    const [shouldSetlovePointsAmount, setShouldSetLovePointsAmount] = useState<boolean>(true)
    const [getEasyrewards, { data, loading }] = useGetEasyrewardsLazyQuery()
    const pendingQueryRef = useRef(false)

    const timerRef = useRef<NodeJS.Timer>()
    useEffect(() => {
        if (triggerSearch !== undefined) return
        clearTimeout(timerRef.current)
        timerRef.current = setTimeout(() => {
            if (search.length >= 1 && search.length <= 5) {
                getEasyrewards({ variables: { easyrewards_id: search } })
            }
        }, 300)
    }, [search])

    useEffect(() => {
        if (!triggerSearch) return
        if (search.length >= 1 && search.length <= 5) {
            pendingQueryRef.current = true
            getEasyrewards({ variables: { easyrewards_id: search } })
        } else {
            onNotFound?.()
        }
    }, [triggerSearch])

    useEffect(() => {
        if (data?.obten_saldo?.saldo !== undefined && shouldSetlovePointsAmount) {
            setLovePointsAmount({ id: search.slice(0, 5), saldo: data.obten_saldo.saldo ?? 0 })
            setShouldSetLovePointsAmount(false)
            pendingQueryRef.current = false
        } else {
            setShouldSetLovePointsAmount(true)
            if (pendingQueryRef.current) {
                pendingQueryRef.current = false
                onNotFound?.()
            }
        }
    }, [data, search, setLovePointsAmount])

    return (
        <Controller
            control={controlParams ? controlParams : control}
            name={`extra.${index}.number`}
            rules={{
                required: "Campo obligatorio",
                minLength: 1,
                maxLength: 5,
            }}
            render={({ field: { value, onChange }, formState: { errors } }) => (
                <div className={className}>
                    <InputText
                        loader={loading}
                        icon={Icon}
                        iconProps={{
                            color: "var(--header-dark)",
                            height: 16,
                            width: 16,
                            name: "iconHash",
                        }}
                        inputWrapperClass={width ? "love-points__input--fluid" : "love-points__input"}
                        label="Número de membresía"
                        type="text"
                        placeholder="Máximo 5 dígitos"
                        value={value}
                        onChange={(e) => {
                            const newValue = e.target.value
                            if (validateOnlyNumbers(newValue, 5)) onChange(newValue)
                            setSearch(newValue)
                        }}
                        error={errors?.extra?.[0]?.number}
                        errorhinttext={errors?.extra?.[0]?.number ? "Campo obligatorio" : ""}
                    />
                </div>
            )}
        />
    )
}

export default LovePointsInput
